"use strict";

exports.__esModule = true;
exports.TextAlignmentPicker = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Translator = require("../../Core/Translator");
var _excluded = ["value", "onChange"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Renders left, center, right and justify buttons for aligning text.
 */
var TextAlignmentPicker = exports.TextAlignmentPicker = /*#__PURE__*/function (_Component) {
  function TextAlignmentPicker() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleClickLeft = function () {
      return _this.props.onChange("left");
    };
    _this.handleClickCenter = function () {
      return _this.props.onChange("center");
    };
    _this.handleClickRight = function () {
      return _this.props.onChange("right");
    };
    _this.handleClickJustify = function () {
      return _this.props.onChange("justify");
    };
    return _this;
  }
  _inheritsLoose(TextAlignmentPicker, _Component);
  var _proto = TextAlignmentPicker.prototype;
  _proto.render = function render() {
    var _this2 = this;
    // eslint-disable-next-line no-unused-vars
    var _this$props = this.props,
      value = _this$props.value,
      onChange = _this$props.onChange,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var icon = value ? "align-" + value : "align-left";
    return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref) {
      var translate = _ref.translate;
      return /*#__PURE__*/_react["default"].createElement(_core.Popover, {
        minimal: true,
        position: _core.Position.BOTTOM_LEFT,
        content: /*#__PURE__*/_react["default"].createElement(_core.Menu, null, /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
          icon: _icons.IconNames.ALIGN_LEFT,
          active: value === "left",
          onClick: _this2.handleClickLeft,
          text: translate("TextAlignmentPicker.alignLeft.text", "Left")
        }), /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
          icon: _icons.IconNames.ALIGN_CENTER,
          active: value === "center",
          onClick: _this2.handleClickCenter,
          text: translate("TextAlignmentPicker.alignCenter.text", "Center")
        }), /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
          icon: _icons.IconNames.ALIGN_RIGHT,
          active: value === "right",
          onClick: _this2.handleClickRight,
          text: translate("TextAlignmentPicker.alignRight.text", "Right")
        }), /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
          icon: _icons.IconNames.ALIGN_JUSTIFY,
          active: value === "justify",
          onClick: _this2.handleClickJustify,
          text: translate("TextAlignmentPicker.alignJustify.text", "Justify")
        }))
      }, /*#__PURE__*/_react["default"].createElement(_core.Button, _extends({
        icon: icon
      }, extra)));
    });
  };
  return TextAlignmentPicker;
}(_react.Component);